﻿import React from 'react';

import { Button, ButtonProps, Tooltip } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt as faPickReport } from '@fortawesome/pro-solid-svg-icons';

interface Props extends Omit<ButtonProps, 'onClick'>  {
    active: boolean,
    setActive: (active: boolean) => void,
    hideTooltip?: boolean,
}

const PickReportButton: React.FC<Props> = ({
    active,
    setActive,
    hideTooltip,
    ...buttonProps
}) => {

    const {
        type = "primary",
        size, // = "small",
        ...rest
    } = buttonProps;  

    return (
        <Tooltip placement="right"
            title={hideTooltip ? '' : active ? 'Disable pick reports' : 'Enable pick reports'} >
            <Button
                type={type} size={size}
                onClick={() => setActive(!active)}                
                icon={<FontAwesomeIcon icon={faPickReport} fixedWidth
                    color={active ? 'yellow' : undefined}
                />}
                {...rest}
            />
        </Tooltip>
    )
}

export default PickReportButton;